




import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
  },
})
export default class PageReviews extends Vue {}
